module.exports = __webpack_public_path__ + "static/media/KH.d9776cb1.svg";